export default "__VITE_ASSET__C3A8apw3__"